export default __webpack_public_path__ + "static/media/093-exchange.6dcc355c.png";